
/**
 * 
 */
export namespace TouchCardChallengeKind {

    export enum GeneralValue {
        /** 奖金 */
        AWARD_NUM = 5000000,
    }

    /** 牌型数据区间 */
    export const CardTypeArea = [
        // [1, 9],
        [12,19],
        // [21,29],
    ]

    export const CardTouchList = [
        // 1,2,3,4,5,6,7,8,9
        12,13,14,15,16,17,18,19
        // , 21,22,23,24,25,26,27,28,29
    ];


}

